export default "__VITE_ASSET__6b12e29d__"